"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const new_item_1 = __importDefault(require("./new-item"));
class NewGatewayTrustedDeviceUntrustRequest extends new_item_1.default {
    constructor(newGatewayTrustedDeviceUntrustRequest) {
        super();
        this.assetCode = newGatewayTrustedDeviceUntrustRequest.assetCode;
        this.gatewayId = newGatewayTrustedDeviceUntrustRequest.gatewayId;
    }
}
exports.default = NewGatewayTrustedDeviceUntrustRequest;
//# sourceMappingURL=new-gatewayTrustedDeviceUntrustRequest.js.map